var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMandiantFlareProdLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "MandiantFlareProdLogo",
    xmlns: "http://www.w3.org/2000/svg",
    width: 74,
    height: 75,
    viewBox: "0 0 74 75",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_297",
    "data-name": "Group 297",
    transform: "translate(-596.604 -552.489)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_155",
    "data-name": "Rectangle 155",
    width: 74,
    height: 75,
    rx: 6,
    transform: "translate(596.604 552.489)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1981",
    "data-name": "Path 1981",
    d: "M49.638-597.574c.292.257.238.823-.173,1.8-.336.791-.91,2.116-4.713,10.8a27.526,27.526,0,0,0-1.257,3.121c.033.107.834.139,3.542.139,3.434,0,3.488,0,3.738.235a.8.8,0,0,1,.249.534c0,.267-.726,1.871-3.672,8.113l-.986,2.095,1.528,3.249c.845,1.785,2.048,4.329,2.665,5.654s1.571,3.314,2.091,4.436,1.181,2.512,1.463,3.1,1.083,2.3,1.787,3.794,1.452,3.089,1.668,3.527c.455.919.477,1.229.152,1.571l-.227.246h-3.4a15.988,15.988,0,0,1-3.781-.16c-.433-.182-.628-.545-3.163-6.093-.834-1.828-2.21-4.831-3.055-6.68s-1.6-3.442-1.69-3.527c-.1-.107-.184-.118-.26-.043-.1.1-.8,1.539-2.6,5.387-1.17,2.49-3.434,7.322-3.846,8.177-.228.47-.617,1.293-.867,1.838a3.941,3.941,0,0,1-.683,1.09,1.95,1.95,0,0,1-1.582-.086c-.195-.214-.271-.363-5.33-11.116-1.82-3.848-3.326-7.022-3.347-7.055-.184-.182-.152-.246-4.442,9.342-1,2.234-2.177,4.853-2.611,5.825a12.944,12.944,0,0,1-1.083,2.074c-.563.577-.715.6-4.4.6-3.315,0-3.38,0-3.629-.235-.466-.428-.65.075,2.438-6.445,1.246-2.651,2.73-5.793,3.3-7s1.376-2.939,1.809-3.848c3.64-7.717,4.344-9.256,4.29-9.459-.032-.118-.888-1.967-1.907-4.1-1.928-4.072-2.037-4.414-1.625-4.82.206-.2.358-.214,3.608-.214,4.117,0,3.911-.064,4.626,1.347.271.524,1.527,3.26,2.806,6.082s3.12,6.862,4.106,8.979,1.852,4.008,1.939,4.2c.1.235.217.342.325.321a17.027,17.027,0,0,0,1.582-3.078c3-6.542,4.626-10.208,4.583-10.336-.043-.107-1.116-.139-5.048-.139-3.228,0-5.07-.043-5.211-.107a2.034,2.034,0,0,1-.639-1.2,1.079,1.079,0,0,1,.2-.524c.1-.16,2.091-2.319,4.42-4.81s4.81-5.163,5.525-5.932c3.922-4.254,9.934-10.635,10.1-10.721A.51.51,0,0,1,49.638-597.574Z",
    transform: "translate(4.299 607)",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMandiantFlareProdLogo);
export default __webpack_public_path__ + "static/media/MandiantFlareProdLogo.32472b1b354daf322fcc38b3c7e19ec4.svg";
export { ForwardRef as ReactComponent };